import React from 'react';
import { truncateText } from './truncateText';

/**
 * Truncated text template component
 */
export const TextTemplate: React.FC<{ text: string; maxLength?: number }> = ({
  text,
  maxLength = 50,
}) => {
  return <div title={text}>{truncateText(text, maxLength)}</div>;
};

export default TextTemplate;
